import { appRoute } from "routes/app/home.runtime"
import { pdfRoute } from "routes/pdf/pdf.runtime"
import { FacilityScheduleImpl } from "routes/facilities/facility-schedule-impl"
import { printRoute } from "routes/print/print.runtime"

appRoute.register("facilities/schedule/:id", <FacilityScheduleImpl $lazy />)
pdfRoute.register("facilities/schedule/:id", <FacilityScheduleImpl $lazy />)
printRoute.register("facilities/schedule/:id", <FacilityScheduleImpl $lazy />)
